import Link from "next/link";
import { Button } from "~/components/v3/themed/Button";

type Props = {
    communitySlug: string;
    hasSponsorshipPackages: boolean;
};

const PartnerWithUsButton = ({
    communitySlug,
    hasSponsorshipPackages,
}: Props) => {
    if (!hasSponsorshipPackages) return false;
    return (
        <Link href={`/${communitySlug}/sponsors`} target="_blank">
            <Button variant="secondary">Partner with us</Button>
        </Link>
    );
};

export default PartnerWithUsButton;
